export default __webpack_public_path__ + "static/media/video-thumbnail.3e3c83a4.png";